import React from 'react';
import './Footer.css';

function Footer() {
    return(
        <>
            <footer>
                <section className='footer-section'>
                    <hr />
                    <p className='footer-content'>Made with <i className="fas fa-heart"></i> by <a href="https://karthik.live/" rel="noopener">Karthik Shetty</a></p>
                </section>
                <section className='footer link section'>
                    
                </section>
            </footer>
        </>
    );
}

export default Footer;